
import React, { useState, useEffect } from 'react';
import {
  Accordion, Table, Badge, Alert, Form, Row, Col, Button, InputGroup, Modal
} from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash, FaCheck, FaTimes } from 'react-icons/fa';
import axios from 'axios';

const CCPAInventoryTab = ({ userData, onScoreUpdate, showNotification, region, refreshActivities }) => {
  const [inventoryItems, setInventoryItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [newItem, setNewItem] = useState({
  processingActivityName: '',
  dataType: '',
  dataSubjectCategory: '',
  processorThirdParty: '',
  ccpaCategory: 'Personal Information',
  businessPurpose: '',
  sourcesOfData: '',
  thirdPartySharing: '',
  saleStatus: 'Not Sold',
  retentionPeriod: '',
  location: '',
  encryptedAtRest: false,
  encryptedInTransit: false
});

  const headers = {
    Region: region,
    UserId: userData?.['cognito:username'] 
  };

  const CCPA_CATEGORIES = [
    'Personal Information',
    'Sensitive Personal Information', 
    'Commercial Information',
    'Biometric Information',
    'Internet Activity',
    'Geolocation Data',
    'Professional Information',
    'Education Information',
    'Inferences'
  ];

  useEffect(() => {
    fetchInventoryItems();
  }, []);

  const fetchInventoryItems = async () => {
    try {
      const res = await axios.get('https://p4m3zpf7x0.execute-api.ap-southeast-2.amazonaws.com/prod/api/ccpa/inventory/list', { headers });
      setInventoryItems(res.data);
      calculateComplianceScore(res.data);
    } catch (error) {
      console.error('Error fetching inventory:', error);
    }
  };

  // const calculateComplianceScore = (items) => {
  //   if (items.length === 0) {
  //     onScoreUpdate(0);
  //     return;
  //   }

  //   const fullyCompliant = items.filter(item => 
  //     item.dataType && item.ccpaCategory && item.businessPurpose && 
  //     item.sourcesOfData && item.saleStatus && item.retentionPeriod
  //   ).length;

  //   // CCPA scoring focuses on transparency and consumer rights
  //   const hasOptOutMechanism = items.filter(item => 
  //     item.saleStatus === 'Not Sold' || item.saleStatus === 'Opt-Out Available'
  //   ).length;

  //   const transparencyScore = (fullyCompliant / items.length) * 60;
  //   const optOutScore = (hasOptOutMechanism / items.length) * 40;
    
  //   const score = Math.round(transparencyScore + optOutScore);
  //   onScoreUpdate(score);
  // };
const calculateComplianceScore = (items) => {
  if (items.length === 0) {
    if (onScoreUpdate) onScoreUpdate(0);
    return;
  }

  const fullyCompliant = items.filter(item =>
   item.processingActivityName &&
item.dataType &&
item.dataSubjectCategory &&
item.processorThirdParty &&
item.ccpaCategory &&
item.businessPurpose &&
item.sourcesOfData &&
item.saleStatus &&
item.retentionPeriod
  ).length;

  const hasOptOutMechanism = items.filter(item =>
    item.saleStatus === "Not Sold" || item.saleStatus === "Opt-Out Available"
  ).length;

  const transparencyScore = (fullyCompliant / items.length) * 60;
  const optOutScore = (hasOptOutMechanism / items.length) * 40;

  const score = Math.round(transparencyScore + optOutScore);

  if (onScoreUpdate) onScoreUpdate(score);
};
  const handleSave = async () => {
    try {
      const payload = { ...newItem };
      
      if (editingItem) {
        await axios.put(`https://jayir7tq1a.execute-api.ap-southeast-2.amazonaws.com/prod/api/ccpa/inventory/update/${editingItem.id}`, payload, { headers });
        await logActivity(`Updated CCPA inventory item: ${payload.dataType}`, "warning");
      } else {
        await axios.post('https://xzuiv6v08a.execute-api.ap-southeast-2.amazonaws.com/prod/api/ccpa/inventory/create', payload, { headers });
        await logActivity(`Added new CCPA inventory item: ${payload.dataType}`, "success");
      }

      showNotification('Inventory item saved successfully!');
      fetchInventoryItems();
      resetForm();
    } catch (error) {
      console.error('Error saving inventory item:', error);
      showNotification('Error saving inventory item', 'danger');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        await axios.delete(`https://7q1tzvo4q1.execute-api.ap-southeast-2.amazonaws.com/prod/api/ccpa/inventory/delete/${id}`, { headers });
        await logActivity(`Deleted CCPA inventory item`, "danger");
        showNotification('Item deleted successfully!');
        fetchInventoryItems();
      } catch (error) {
        console.error('Error deleting item:', error);
        showNotification('Error deleting item', 'danger');
      }
    }
  };

  const resetForm = () => {
    setNewItem({
       processingActivityName: '',
  dataType: '',
  dataSubjectCategory: '',
  processorThirdParty: '',
  ccpaCategory: 'Personal Information',
  businessPurpose: '',
  sourcesOfData: '',
  thirdPartySharing: '',
  saleStatus: 'Not Sold',
  retentionPeriod: '',
  location: '',
  encryptedAtRest: false,
  encryptedInTransit: false
    });
    setEditingItem(null);
    setShowModal(false);
  };

const logActivity = async (message, badge = "info") => {
 
  
  try {
    // ✅ Map frontend fields to backend entity fields
    const payload = {
      action: badge,                    // badge → action
      module: "Inventory",              // Add module field
      description: message                  // message → details
      // userId and timestamp set by backend
    };
    
    
    
    const response = await axios.post(
      "https://wjioewyrif.execute-api.ap-southeast-2.amazonaws.com/prod/api/ccpa/activities/create",  // ✅ Correct endpoint
      payload,     
      { headers }  // ✅ Send headers properly
    );
    
    
    if (refreshActivities) {
        await refreshActivities();
      }


  } catch (err) {
    console.error('❌ Error logging inventory activity:', err);
    
    if (err.response) {
      console.error('🔥 Server Error Details:');
      console.error('Status:', err.response.status);
      console.error('Data:', err.response.data);
    }
    
    console.warn("Failed to log activity:", err.message);
  }
};
  return (
    <>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>CCPA Data Inventory Management</Accordion.Header>
          <Accordion.Body>
            <Alert variant="info">
              <strong>CCPA Requirement:</strong> Businesses must maintain records of personal information categories collected, 
              sources of data, business purposes, and third-party sharing[16][22].
            </Alert>

            <Row className="mb-3">
              <Col>
                <Button variant="primary" onClick={() => setShowModal(true)}>
                  <FaPlus /> Add Data Asset
                </Button>
              </Col>
            </Row>

            <Table striped bordered hover responsive>
              <thead>
                <tr>
                 <th>Processing Activity</th>
<th>Data Type</th>
                  <th>CCPA Category</th>
                  <th>Data Subjects</th>
<th>Processor / Third Party</th>
                  <th>Business Purpose</th>
                  <th>Data Sources</th>
                  <th>Third-Party Sharing</th>
                  <th>Sale Status</th>
                  <th>Retention</th>
                  <th>Encrypted</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {inventoryItems.map((item, index) => (
                  <tr key={index}>
                    <td>{item.processingActivityName || '-'}</td>
                    <td>{item.dataType}</td>
                    <td>
                      <Badge bg={
                        item.ccpaCategory === 'Sensitive Personal Information' ? 'danger' :
                        item.ccpaCategory === 'Personal Information' ? 'warning' : 'info'
                      }>
                        {item.ccpaCategory}
                      </Badge>
                    </td>
                    <td>{item.dataSubjectCategory || '-'}</td>
<td>{item.processorThirdParty || '-'}</td>
                    <td>{item.businessPurpose}</td>
                    <td>{item.sourcesOfData}</td>
                    <td>{item.thirdPartySharing}</td>
                    <td>
                      <Badge bg={
                        item.saleStatus === 'Not Sold' ? 'success' :
                        item.saleStatus === 'Opt-Out Available' ? 'primary' : 'warning'
                      }>
                        {item.saleStatus}
                      </Badge>
                    </td>
                    <td>{item.retentionPeriod}</td>
                    <td>
                      At Rest: {item.encryptedAtRest ? <FaCheck className="text-success" /> : <FaTimes className="text-danger" />}<br/>
                      In Transit: {item.encryptedInTransit ? <FaCheck className="text-success" /> : <FaTimes className="text-danger" />}
                    </td>
                    <td>
                      <Button size="sm" variant="outline-warning" className="me-1" 
                              onClick={() => { setEditingItem(item); setNewItem(item); setShowModal(true); }}>
                        <FaEdit />
                      </Button>
                      <Button size="sm" variant="outline-danger" onClick={() => handleDelete(item.id)}>
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <Modal show={showModal} onHide={resetForm} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{editingItem ? 'Edit' : 'Add'} Data Asset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
           <Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Processing Activity Name</Form.Label>
      <Form.Control
        type="text"
        value={newItem.processingActivityName}
        onChange={(e) =>
          setNewItem({ ...newItem, processingActivityName: e.target.value })
        }
        placeholder="e.g., Consumer Account Management, Marketing Campaigns"
      />
    </Form.Group>
  </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Data Type</Form.Label>
                  <Form.Control
                    type="text"
                    value={newItem.dataType}
                    onChange={(e) => setNewItem({...newItem, dataType: e.target.value})}
                    placeholder="e.g., Customer Email Addresses"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>CCPA Category</Form.Label>
                  <Form.Select
                    value={newItem.ccpaCategory}
                    onChange={(e) => setNewItem({...newItem, ccpaCategory: e.target.value})}
                  >
                    {CCPA_CATEGORIES.map(cat => (
                      <option key={cat} value={cat}>{cat}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
               <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Data Subject Category</Form.Label>
      <Form.Select
        value={newItem.dataSubjectCategory}
        onChange={(e) =>
          setNewItem({ ...newItem, dataSubjectCategory: e.target.value })
        }
      >
        <option value="">Select Data Subject</option>
        <option value="Consumers">Consumers</option>
        <option value="Customers">Customers</option>
        <option value="Employees">Employees</option>
        <option value="Children">Children</option>
        <option value="Website Visitors">Website Visitors</option>
        <option value="Household Members">Household Members</option>
      </Form.Select>
    </Form.Group>
  </Col>
</Row>
           
            <Form.Group className="mb-3">
              <Form.Label>Business Purpose</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={newItem.businessPurpose}
                onChange={(e) => setNewItem({...newItem, businessPurpose: e.target.value})}
                placeholder="e.g., To provide customer support and process transactions"
              />
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Sources of Data</Form.Label>
                  <Form.Control
                    type="text"
                    value={newItem.sourcesOfData}
                    onChange={(e) => setNewItem({...newItem, sourcesOfData: e.target.value})}
                    placeholder="e.g., Directly from consumers, Website forms"
                  />
                </Form.Group>
              </Col>
              <Row>
  <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Processor / Third Party</Form.Label>
      <Form.Control
        type="text"
        value={newItem.processorThirdParty}
        onChange={(e) =>
          setNewItem({ ...newItem, processorThirdParty: e.target.value })
        }
        placeholder="Example: Internal Only, AWS, Salesforce, Marketing Partner"
      />
    </Form.Group>
  </Col>
</Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Third-Party Sharing</Form.Label>
                  <Form.Control
                    type="text"
                    value={newItem.thirdPartySharing}
                    onChange={(e) => setNewItem({...newItem, thirdPartySharing: e.target.value})}
                    placeholder="e.g., Marketing partners, Service providers"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Sale Status</Form.Label>
                  <Form.Select
                    value={newItem.saleStatus}
                    onChange={(e) => setNewItem({...newItem, saleStatus: e.target.value})}
                  >
                    <option value="Not Sold">Not Sold</option>
                    <option value="Sold">Sold</option>
                    <option value="Opt-Out Available">Opt-Out Available</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Retention Period</Form.Label>
                  <Form.Control
                    type="text"
                    value={newItem.retentionPeriod}
                    onChange={(e) => setNewItem({...newItem, retentionPeriod: e.target.value})}
                    placeholder="e.g., 2 years after account closure"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Storage Location</Form.Label>
              <Form.Control
                type="text"
                value={newItem.location}
                onChange={(e) => setNewItem({...newItem, location: e.target.value})}
                placeholder="e.g., US-West-1 (AWS)"
              />
            </Form.Group>
            <Row>
              <Col md={6}>
                <Form.Check
                  type="checkbox"
                  label="Encrypted at Rest"
                  checked={newItem.encryptedAtRest}
                  onChange={(e) => setNewItem({...newItem, encryptedAtRest: e.target.checked})}
                />
              </Col>
              <Col md={6}>
                <Form.Check
                  type="checkbox"
                  label="Encrypted in Transit"
                  checked={newItem.encryptedInTransit}
                  onChange={(e) => setNewItem({...newItem, encryptedInTransit: e.target.checked})}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={resetForm}>Cancel</Button>
          <Button variant="primary" onClick={handleSave}>
            {editingItem ? 'Update' : 'Create'} Asset
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CCPAInventoryTab;
